import { hdRoutes, smoothRoutes } from '@/mocks/routeData';

function RouteColumn({
  tone,
  icon,
  name,
  tagline,
  items,
}: {
  tone: 'teal' | 'rose';
  icon: string;
  name: string;
  tagline: string;
  items: { name: string; eps: string; extra: string; quality: string; live: string }[];
}) {
  const map = {
    teal: {
      text: 'text-teal-700', soft: 'bg-teal-100 text-teal-700', bar: 'bg-teal-500', ring: 'ring-teal-500',
      chip: 'bg-teal-50 text-teal-700', hover: 'hover:border-teal-300', play: 'bg-teal-500 hover:bg-teal-600',
    },
    rose: {
      text: 'text-rose-700', soft: 'bg-rose-100 text-rose-700', bar: 'bg-rose-500', ring: 'ring-rose-500',
      chip: 'bg-rose-50 text-rose-700', hover: 'hover:border-rose-300', play: 'bg-rose-500 hover:bg-rose-600',
    },
  }[tone];

  return (
    <div className="flex flex-col rounded-2xl border border-stone-200/80 bg-white">
      <div className="flex items-center justify-between border-b border-stone-100 px-5 py-4 md:px-6">
        <div className="flex items-center gap-3">
          <span className={`flex h-10 w-10 items-center justify-center rounded-xl text-xl ${map.soft}`}>
            <i className={icon} />
          </span>
          <div>
            <h3 className="text-base font-bold text-stone-900 md:text-lg">{name}</h3>
            <p className="text-xs text-stone-400">{tagline}</p>
          </div>
        </div>
        <span className={`hidden rounded-full px-2.5 py-1 text-[11px] font-semibold sm:inline ${map.soft}`}>
          {items.length} 部热映
        </span>
      </div>
      <div className="flex flex-1 flex-col divide-y divide-stone-100">
        {items.map((it) => (
          <a
            key={it.name}
            href="#hot"
            className="group flex cursor-pointer items-center gap-3 px-5 py-4 transition hover:bg-stone-50 md:px-6"
          >
            <span
              className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-white ${map.play} transition`}
            >
              <i className="ri-play-fill text-lg" />
            </span>
            <div className="min-w-0 flex-1">
              <div className="flex flex-wrap items-center gap-x-2 gap-y-0.5">
                <h4 className="truncate text-sm font-bold text-stone-800 group-hover:text-stone-950">{it.name}</h4>
                <span className={`rounded px-1.5 py-0.5 text-[10px] font-semibold ${map.chip}`}>{it.quality}</span>
              </div>
              <p className="mt-0.5 truncate text-xs text-stone-400">{it.eps} · {it.extra}</p>
            </div>
            <span className="flex shrink-0 items-center gap-1 rounded-full bg-emerald-50 px-2 py-0.5 text-[11px] font-semibold text-emerald-600">
              <i className="ri-record-circle-line text-xs" /> {it.live}
            </span>
          </a>
        ))}
      </div>
      <a
        href="#zone"
        className="flex cursor-pointer items-center justify-center gap-1 border-t border-stone-100 py-3 text-sm font-medium text-stone-500 transition hover:text-orange-600"
      >
        查看全部 <i className="ri-arrow-down-s-line" />
      </a>
    </div>
  );
}

export default function RouteZones() {
  return (
    <section id="zone" className="border-y border-stone-200/60 bg-white">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="flex items-center gap-3">
              <span className="h-px w-10 bg-orange-400" />
              <span className="text-xs font-semibold uppercase tracking-[0.25em] text-orange-600">ROUTE · 线路分区</span>
            </div>
            <h2 className="font-mag mt-3 text-2xl font-black text-stone-900 md:text-4xl">
              流畅与高清，各取所需
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-6 text-stone-500 md:text-right">
            同一部剧两套线路都会挂出，先试推荐路线，不满意随时可切，进度不受影响。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 lg:grid-cols-2">
          <RouteColumn
            tone="teal"
            icon="ri-speed-line"
            name="流畅线路"
            tagline="秒开不缓冲 · 适合快节奏追更"
            items={smoothRoutes}
          />
          <RouteColumn
            tone="rose"
            icon="ri-hd-line"
            name="高清线路"
            tagline="4K 原片 · 大屏画质首选"
            items={hdRoutes}
          />
        </div>
      </div>
    </section>
  );
}